import styled from "styled-components";
import "./font/font.css";
import { Link } from "react-router-dom";

export const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: #00439c;
  justify-content: flex-start;
  font-family: "SST";
`;

export const Navbar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 8px;
  padding: 16px 20px 0;
  cursor: pointer;

  img {
    height: 51px;
  }
  .balance-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }
  .balance-text {
    text-align: right;
    color: #fff;
    font-family: "SST", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px; /* 133.333% */
    letter-spacing: 0.15px;
  }
  .balance-value {
    color: #fff;
    text-align: right;
    font-family: "SST", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px; /* 133.333% */
    letter-spacing: 0.15px;
  }
`;

export const Page = styled.div`
  background-color: #00439c;
  color: #ffffff;
  padding: 24px;
  font-family: "SST", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  .link {
    text-decoration: underline;
    color: #fff;
  }
`;

export const Heading = styled.h1`
  font-size: 28px;
  font-weight: 900;
  line-height: 40px;
  text-align: center;
  font-family: "SST", sans-serif;
  color: #fff;
`;

export const SubHeading = styled.h2`
  font-size: 20px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
  font-family: "SST", sans-serif;
  color: #fff;
`;

export const Paragraph = styled.p`
  font-size: 15px;
  font-weight: 300;
  line-height: 24px;
  text-align: ${({ align }) => align || "center"};
  letter-spacing: 0.5px;
  font-family: "SST", sans-serif;
  color: #fff;
  width: 100%;
`;

export const ScheduleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const ScheduleItem = styled.div`
  text-align: left;
  color: #fff;
  font-family: "SST", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
  width: 100%;
  line-height: 24px; /* 160% */
  letter-spacing: 0.5px;
  display: flex;
  flex-direction: row;
  align-items: space-between;
  gap: 20px;
`;

export const Separator = styled.div`
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "100px")};
  margin: 6px auto 0;
  height: 1px;
  background-color: #fff !important;
`;

export const Time = styled.div`
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;
  font-family: "SST", sans-serif;
  color: #fff;
  width: 92px;
`;

export const FooterImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px;
  gap: 16px;
  background-color: #000000;
  img {
    height: 33px;
  }

  .powered-by {
    color: #fff;
    font-family: "Inter";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
  }

  a {
    font-family: "Inter";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
    text-decoration: underline;
    color: #fff;
  }

  p {
    color: white;
  }

  .copyToClipboard {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    img {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
`;
